import { render, staticRenderFns } from "./contactForm.vue?vue&type=template&id=54ee5aa1"
import script from "./contactForm.vue?vue&type=script&lang=ts"
export * from "./contactForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports